module.exports = __webpack_public_path__ + "static/media/check-circle-error.668b73b5.svg";